module.exports = __webpack_public_path__ + "img/interior-01.b1bd9de6.png";